import { sidebarReducer } from './SideBar';
import { authReducer } from './Auth';
import { notificationReducer } from './Notification';

/* below are dynamic, put shared static one above this */
import { XrsBTrxReducer } from './XrsBTrx';
import { CmnBlogReducer } from './CmnBlog';
import { SqlReportReducer } from './SqlReport'

export default {
  auth: authReducer,
  sidebar: sidebarReducer,
  notification: notificationReducer,

  /* dynamic go to here */
  XrsBTrx: XrsBTrxReducer,
  SqlReport: SqlReportReducer,
  CmnBlog: CmnBlogReducer
}



// WEBPACK FOOTER //
// ./src/redux/index.js